import { QuestionCircleOutlined, BookOutlined } from "@ant-design/icons";
import { Button, Collapse, Divider, Drawer, Space, Tag, Typography } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FULL_FLOW_HELP, MODULE_HELP } from "../help/moduleHelp";

const { Title, Text } = Typography;

export const HelpDrawer = () => {
  const [open, setOpen] = useState(false);
  const [showFullFlow, setShowFullFlow] = useState(false);
  const location = useLocation();

  const pageHelp = MODULE_HELP[location.pathname] ?? null;
  const help = showFullFlow ? FULL_FLOW_HELP : (pageHelp ?? FULL_FLOW_HELP);

  const handleOpen = () => {
    setShowFullFlow(false);
    setOpen(true);
  };

  return (
    <>
      <Button
        shape="circle"
        className="icon-button"
        icon={<QuestionCircleOutlined />}
        onClick={handleOpen}
        title="Help"
      />

      <Drawer
        title={
          <Space align="center" size={10}>
            <span style={{ fontSize: 18 }}>{help.icon}</span>
            <div>
              <div style={{ fontWeight: 700, lineHeight: 1.3 }}>{help.title}</div>
              <Text type="secondary" style={{ fontSize: 12, fontWeight: 400 }}>
                {help.tagline}
              </Text>
            </div>
          </Space>
        }
        placement="right"
        width={440}
        open={open}
        onClose={() => setOpen(false)}
        styles={{
          header: { paddingBottom: 12 },
          body: { paddingTop: 0 }
        }}
        extra={
          pageHelp && !showFullFlow ? (
            <Button
              size="small"
              icon={<BookOutlined />}
              onClick={() => setShowFullFlow(true)}
            >
              Full Flow
            </Button>
          ) : pageHelp && showFullFlow ? (
            <Button
              size="small"
              onClick={() => setShowFullFlow(false)}
            >
              ← This Page
            </Button>
          ) : null
        }
      >
        <Collapse
          bordered={false}
          defaultActiveKey={help.sections.map((_, i) => String(i))}
          style={{ background: "transparent" }}
          items={help.sections.map((section, i) => ({
            key: String(i),
            label: (
              <Text strong style={{ fontSize: 13 }}>
                {section.heading}
              </Text>
            ),
            children: (
              <div style={{ paddingLeft: 4, paddingBottom: 4 }}>
                {section.content}
              </div>
            ),
            style: {
              marginBottom: 4,
              borderRadius: 6,
              border: "1px solid var(--app-bg, #f0f0f0)",
            }
          }))}
        />

        <Divider style={{ margin: "16px 0 8px" }} />
        <div style={{ textAlign: "center" }}>
          <Button
            type="link"
            size="small"
            icon={<BookOutlined />}
            onClick={() => setShowFullFlow(!showFullFlow)}
          >
            {showFullFlow ? "Back to page help" : "View full system workflow"}
          </Button>
        </div>
      </Drawer>
    </>
  );
};
